var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{on:{"click":function($event){return _vm.$emit('toggle', !_vm.hidden)}}},[_c('Icon',{attrs:{"name":_vm.hidden ? 'eye-closed' : 'eye-opened',"pointer":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }